import { render, staticRenderFns, recyclableRender, components } from "./uLink.vue?vue&type=template&id=c7c66338&"
var renderjs
import script from "./uLink.vue?vue&type=script&lang=js&"
export * from "./uLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uLink.vue"
export default component.exports